import resso from 'resso';

export const _fakeToken = "68a141fc6d9b1d714ff5562ce7d1a5a6"

const user = resso({
  token: ""
});

export default user